import { render, staticRenderFns } from "./CollisionTypesViz.vue?vue&type=template&id=3c941f62&scoped=true"
import script from "./CollisionTypesViz.vue?vue&type=script&lang=js"
export * from "./CollisionTypesViz.vue?vue&type=script&lang=js"
import style0 from "./CollisionTypesViz.vue?vue&type=style&index=0&id=3c941f62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c941f62",
  null
  
)

export default component.exports